export var SNACKBAR_INIT = 'SNACKBAR_INIT';
export var SET_SNACKBAR = 'SET_SNACKBAR';
export var INIT_CLOSE_SNACKBAR = 'INIT_CLOSE_SNACKBAR';
export var CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export var HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export var INIT_SNACKBAR_CLOSING_WITH_ANSWER = 'INIT_SNACKBAR_CLOSING_WITH_ANSWER';
export var CLOSING_SNACKBAR_WITH_ANSWER = 'CLOSING_SNACKBAR_WITH_ANSWER';